// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-v-text-field__details[data-v-3c3f534e] {\n  display: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
